// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color:#6d6864;
  --sec-color: white;
}

html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  font-family: sans-serif;
  font-weight: lighter;
  height: 100%;
  width: 100%;
}

#form {
  background-color: #6d6864;
}

body {
  background-color: #6d6864;
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
}

#rodape {
  max-width: 580px;
  text-align: justify;
  background-color: #6d6864;
}

.form-check-label {
  color: var(--sec-color);
  font-weight: lighter;
  letter-spacing: 0.25rem;
  font-size: 0.9rem;
}

.col-form-label {
  letter-spacing: 0.25rem;
  color: var(--sec-color);
}

#rodape {
  background-color: #6d6864;
  font-size: 0.8rem;
  color: var(--sec-color);
  font-weight: lighter;
  letter-spacing: 0.25rem;
}

#email, #nome {
  padding: 0 0 0 0.5rem;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  color: white;
  font-family: sans-serif;
  font-weight: lighter;
  border-bottom: 1px solid white !important;
}

#email:focus, #nome:focus {
  color: white;
  background-color: none;
  border: none;
  outline: 0;
  box-shadow: none;
}

#email:is(:-webkit-autofill, :autofill), #nome:is(:-webkit-autofill, :autofill) {
  color: white;
  background-color: none;
  border: none;
  outline: 0;
  box-shadow: none;
}

#btn-submit {
  background-color: var(--main-color);
  color: var(--sec-color);
  border: none;
  box-shadow: none;
  border-radius: 1.25rem;
  letter-spacing: 0.25rem;
}

#container-container {
  margin: auto;
  width: 55%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: inherit;
}

.iframe-container {
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;
}

iframe {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait) {
  #container-container {
    width: 100%;
    flex-direction: column;
    padding: 2em;
  }
  body {
    background-color: white;
    background-position: -110% -7%;
    background-repeat: no-repeat;
    background-size: 120%;
  }
  .iframe-container {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/vista-cyrela/styles/main.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,yBAAA;AAEJ;;AAAA;EACI,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,uBAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;AAGJ;;AAAA;EACI,YAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAGJ;;AADA;EACI,YAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,mCAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AAKJ;;AAFA;EACI,YAAA;EAEA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,sBAAA;EACA,WAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AAAA;EACI;IACI,WAAA;IACA,sBAAA;IACA,YAAA;EAGN;EAAE;IACI,uBAAA;IACA,8BAAA;IACA,4BAAA;IACA,qBAAA;EAEN;EACE;IACI,WAAA;EACN;AACF","sourcesContent":[":root{\n    --main-color:#6d6864;\n    --sec-color: white;\n}\n\nhtml, body{\n    overflow-x: hidden;\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    font-weight: lighter;\n    height: 100%;\n    width: 100%;\n}\n#form{\n    background-color: #6d6864;\n}\nbody{\n    background-color: #6d6864;\n    background-position: left;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n#rodape{\n    max-width: 580px;\n    text-align: justify;\n    background-color: #6d6864;\n}\n\n.form-check-label{\n    color: var(--sec-color);\n    font-weight: lighter;\n    letter-spacing: 0.25rem;\n    font-size: 0.9rem;\n}\n\n.col-form-label{\n    letter-spacing: 0.25rem;\n    color: var(--sec-color);\n}\n\n#rodape{\n    background-color: #6d6864;\n    font-size: 0.8rem;\n    color: var(--sec-color);\n    font-weight: lighter;\n    letter-spacing: 0.25rem;\n}\n\n#email, #nome{\n    padding: 0 0 0 0.5rem;\n    margin: 0;\n    border-radius: 0;\n    background-color: transparent;\n    border: none;\n    color: white;\n    font-family: sans-serif;\n    font-weight: lighter;\n    border-bottom: 1px solid white !important;\n}\n\n#email:focus, #nome:focus {\n    color: white;\n    background-color: none;\n    border: none;\n    outline: 0;\n    box-shadow: none;\n}\n#email:is(:-webkit-autofill, :autofill), #nome:is(:-webkit-autofill, :autofill) {\n    color: white;\n    background-color: none;\n    border: none;\n    outline: 0;\n    box-shadow: none;\n}\n#btn-submit{\n    background-color: var(--main-color);\n    color: var(--sec-color);\n    border: none;\n    box-shadow: none;\n    border-radius: 1.25rem;\n    letter-spacing: 0.25rem;\n}\n\n#container-container{\n    margin: auto;\n\n    width: 55%;\n\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    flex-direction: inherit;\n}\n\n.iframe-container{\n    position: relative;\n    padding-bottom: 56.25%;\n    width: 100%;\n}\n\niframe{\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}\n\n@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait)  {\n    #container-container{\n        width: 100%;\n        flex-direction: column;\n        padding: 2em;\n    }\n    \n    body{\n        background-color: white;\n        background-position: -110% -7%;\n        background-repeat: no-repeat;\n        background-size: 120%;\n    }\n\n    .iframe-container{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
